// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
  urlSearchParamsBodySerializer,
} from "./client";
import { client } from "./client.gen";
import type {
  DeleteFoodGroupByGroupIdData,
  DeleteFoodGroupByGroupIdErrors,
  DeleteFoodGroupByGroupIdResponses,
  DeleteFoodItemByFoodIdTagByTagIdData,
  DeleteFoodItemByFoodIdTagByTagIdErrors,
  DeleteFoodItemByFoodIdTagByTagIdResponses,
  DeleteFoodTagByTagIdData,
  DeleteFoodTagByTagIdErrors,
  DeleteFoodTagByTagIdResponses,
  DeleteMenuLoopByMenuLoopIdData,
  DeleteMenuLoopByMenuLoopIdErrors,
  DeleteMenuLoopByMenuLoopIdResponses,
  DeleteMenuMealByMenuIdData,
  DeleteMenuMealByMenuIdErrors,
  DeleteMenuMealByMenuIdResponses,
  DeleteUserAccountByUserIdPermissionByPermissionIdData,
  DeleteUserAccountByUserIdPermissionByPermissionIdErrors,
  DeleteUserAccountByUserIdPermissionByPermissionIdResponses,
  DeleteUserGroupByGroupIdData,
  DeleteUserGroupByGroupIdErrors,
  DeleteUserGroupByGroupIdMembersByUserIdData,
  DeleteUserGroupByGroupIdMembersByUserIdErrors,
  DeleteUserGroupByGroupIdMembersByUserIdResponses,
  DeleteUserGroupByGroupIdPermissionByPermissionIdData,
  DeleteUserGroupByGroupIdPermissionByPermissionIdErrors,
  DeleteUserGroupByGroupIdPermissionByPermissionIdResponses,
  DeleteUserGroupByGroupIdResponses,
  DeleteUserPermissionByPermissionIdData,
  DeleteUserPermissionByPermissionIdErrors,
  DeleteUserPermissionByPermissionIdResponses,
  GetDietProfileByUserIdData,
  GetDietProfileByUserIdErrors,
  GetDietProfileByUserIdResponses,
  GetDietProfileInGroupData,
  GetDietProfileInGroupErrors,
  GetDietProfileInGroupResponses,
  GetFoodGroupByGroupIdData,
  GetFoodGroupByGroupIdErrors,
  GetFoodGroupByGroupIdResponses,
  GetFoodGroupData,
  GetFoodGroupErrors,
  GetFoodGroupResponses,
  GetFoodItemByFoodIdData,
  GetFoodItemByFoodIdErrors,
  GetFoodItemByFoodIdResponses,
  GetFoodItemsData,
  GetFoodItemsDownloadData,
  GetFoodItemsDownloadErrors,
  GetFoodItemsDownloadResponses,
  GetFoodItemSearchData,
  GetFoodItemSearchErrors,
  GetFoodItemSearchResponses,
  GetFoodItemsErrors,
  GetFoodItemsResponses,
  GetFoodRecipeSearchData,
  GetFoodRecipeSearchErrors,
  GetFoodRecipeSearchResponses,
  GetFoodSupplierInfoLookupData,
  GetFoodSupplierInfoLookupErrors,
  GetFoodSupplierInfoLookupResponses,
  GetFoodTagAllData,
  GetFoodTagAllErrors,
  GetFoodTagAllResponses,
  GetFoodTagByTagIdData,
  GetFoodTagByTagIdErrors,
  GetFoodTagByTagIdResponses,
  GetInventoryGfsOrderingFacilityAdminAllData,
  GetInventoryGfsOrderingFacilityAdminAllErrors,
  GetInventoryGfsOrderingFacilityAdminAllResponses,
  GetInventoryGfsOrderingFacilityByProfileIdData,
  GetInventoryGfsOrderingFacilityByProfileIdErrors,
  GetInventoryGfsOrderingFacilityByProfileIdResponses,
  GetInventoryGfsOrderingFacilityData,
  GetInventoryGfsOrderingFacilityErrors,
  GetInventoryGfsOrderingFacilityResponses,
  GetInventoryGfsOrderingOrdersByOrderIdData,
  GetInventoryGfsOrderingOrdersByOrderIdErrors,
  GetInventoryGfsOrderingOrdersByOrderIdResponses,
  GetInventoryGfsOrderingOrdersData,
  GetInventoryGfsOrderingOrdersErrors,
  GetInventoryGfsOrderingOrdersResponses,
  GetInventoryGfsOrderingPurchasingCsvByOrderIdData,
  GetInventoryGfsOrderingPurchasingCsvByOrderIdErrors,
  GetInventoryGfsOrderingPurchasingCsvByOrderIdResponses,
  GetInventoryGfsOrderingPurchasingListData,
  GetInventoryGfsOrderingPurchasingListErrors,
  GetInventoryGfsOrderingPurchasingListResponses,
  GetInventoryGfsOrderingPurchasingOrderCsvAnalysisData,
  GetInventoryGfsOrderingPurchasingOrderCsvAnalysisErrors,
  GetInventoryGfsOrderingPurchasingOrderCsvAnalysisResponses,
  GetInventoryGfsOrderingPurchasingOrderCsvData,
  GetInventoryGfsOrderingPurchasingOrderCsvErrors,
  GetInventoryGfsOrderingPurchasingOrderCsvResponses,
  GetInventoryGfsOrderingPurchasingUpcomingOrdersData,
  GetInventoryGfsOrderingPurchasingUpcomingOrdersErrors,
  GetInventoryGfsOrderingPurchasingUpcomingOrdersResponses,
  GetInventoryStockByFoodIdDetailData,
  GetInventoryStockByFoodIdDetailErrors,
  GetInventoryStockByFoodIdDetailResponses,
  GetInventoryStocksData,
  GetInventoryStocksErrors,
  GetInventoryStocksResponses,
  GetInventoryStocksSearchData,
  GetInventoryStocksSearchErrors,
  GetInventoryStocksSearchResponses,
  GetMenuDailyByQueryDateData,
  GetMenuDailyByQueryDateDownloadData,
  GetMenuDailyByQueryDateDownloadErrors,
  GetMenuDailyByQueryDateDownloadResponses,
  GetMenuDailyByQueryDateErrors,
  GetMenuDailyByQueryDateResponses,
  GetMenuDateRangeFromByDateStartToByDateEndData,
  GetMenuDateRangeFromByDateStartToByDateEndErrors,
  GetMenuDateRangeFromByDateStartToByDateEndResponses,
  GetMenuLoopByMenuLoopIdData,
  GetMenuLoopByMenuLoopIdErrors,
  GetMenuLoopByMenuLoopIdInvolvedFoodsDownloadData,
  GetMenuLoopByMenuLoopIdInvolvedFoodsDownloadErrors,
  GetMenuLoopByMenuLoopIdInvolvedFoodsDownloadResponses,
  GetMenuLoopByMenuLoopIdResponses,
  GetMenuLoopSearchData,
  GetMenuLoopSearchErrors,
  GetMenuLoopSearchResponses,
  GetMenuMealByMenuIdData,
  GetMenuMealByMenuIdErrors,
  GetMenuMealByMenuIdResponses,
  GetMenuMealSearchData,
  GetMenuMealSearchErrors,
  GetMenuMealSearchResponses,
  GetOrderMealByMealOrderTicketIdData,
  GetOrderMealByMealOrderTicketIdErrors,
  GetOrderMealByMealOrderTicketIdResponses,
  GetOrderPortionAggregatedMenuProductionDateFromByDateStartToByDateEndData,
  GetOrderPortionAggregatedMenuProductionDateFromByDateStartToByDateEndErrors,
  GetOrderPortionAggregatedMenuProductionDateFromByDateStartToByDateEndResponses,
  GetOrderTicketsDailyByQueryDateData,
  GetOrderTicketsDailyByQueryDateErrors,
  GetOrderTicketsDailyByQueryDateResponses,
  GetUserAccountByUserIdData,
  GetUserAccountByUserIdErrors,
  GetUserAccountByUserIdResponses,
  GetUserGroupByGroupIdData,
  GetUserGroupByGroupIdErrors,
  GetUserGroupByGroupIdResponses,
  GetUserGroupSearchData,
  GetUserGroupSearchErrors,
  GetUserGroupSearchResponses,
  GetUserPermissionByPermissionIdData,
  GetUserPermissionByPermissionIdErrors,
  GetUserPermissionByPermissionIdResponses,
  PatchDietProfileByUserIdData,
  PatchDietProfileByUserIdErrors,
  PatchDietProfileByUserIdResponses,
  PatchFoodGroupByGroupIdData,
  PatchFoodGroupByGroupIdErrors,
  PatchFoodGroupByGroupIdResponses,
  PatchFoodIngByFoodIdData,
  PatchFoodIngByFoodIdErrors,
  PatchFoodIngByFoodIdResponses,
  PatchFoodItemByFoodIdRecipeByRecipeIdData,
  PatchFoodItemByFoodIdRecipeByRecipeIdErrors,
  PatchFoodItemByFoodIdRecipeByRecipeIdResponses,
  PatchFoodItemsTagsData,
  PatchFoodItemsTagsErrors,
  PatchFoodItemsTagsResponses,
  PatchFoodTagByTagIdData,
  PatchFoodTagByTagIdErrors,
  PatchFoodTagByTagIdResponses,
  PatchInventoryGfsOrderingFacilityByProfileIdDeactivateData,
  PatchInventoryGfsOrderingFacilityByProfileIdDeactivateErrors,
  PatchInventoryGfsOrderingFacilityByProfileIdDeactivateResponses,
  PatchInventoryGfsOrderingFacilityByProfileIdReactivateData,
  PatchInventoryGfsOrderingFacilityByProfileIdReactivateErrors,
  PatchInventoryGfsOrderingFacilityByProfileIdReactivateResponses,
  PatchMenuLoopByMenuLoopIdData,
  PatchMenuLoopByMenuLoopIdErrors,
  PatchMenuLoopByMenuLoopIdResponses,
  PatchMenuMealBatchData,
  PatchMenuMealBatchErrors,
  PatchMenuMealBatchResponses,
  PatchOrderMealByMealOrderTicketIdData,
  PatchOrderMealByMealOrderTicketIdErrors,
  PatchOrderMealByMealOrderTicketIdResponses,
  PatchUserAccountByUserIdData,
  PatchUserAccountByUserIdErrors,
  PatchUserAccountByUserIdResponses,
  PatchUserGroupByGroupIdData,
  PatchUserGroupByGroupIdErrors,
  PatchUserGroupByGroupIdProfileData,
  PatchUserGroupByGroupIdProfileErrors,
  PatchUserGroupByGroupIdProfileResponses,
  PatchUserGroupByGroupIdResponses,
  PatchUserPermissionByPermissionIdData,
  PatchUserPermissionByPermissionIdErrors,
  PatchUserPermissionByPermissionIdResponses,
  PostAuthPasswordResetConfirmData,
  PostAuthPasswordResetConfirmErrors,
  PostAuthPasswordResetConfirmResponses,
  PostAuthPasswordResetRequestData,
  PostAuthPasswordResetRequestErrors,
  PostAuthPasswordResetRequestResponses,
  PostAuthTokenData,
  PostAuthTokenErrors,
  PostAuthTokenResponses,
  PostDietProfileByUserIdData,
  PostDietProfileByUserIdErrors,
  PostDietProfileByUserIdResponses,
  PostFoodGroupData,
  PostFoodGroupErrors,
  PostFoodGroupResponses,
  PostFoodIngData,
  PostFoodIngErrors,
  PostFoodIngGfsScrapperCsvData,
  PostFoodIngGfsScrapperCsvErrors,
  PostFoodIngGfsScrapperCsvResponses,
  PostFoodIngResponses,
  PostFoodItemApprovalByFoodIdData,
  PostFoodItemApprovalByFoodIdErrors,
  PostFoodItemApprovalByFoodIdResponses,
  PostFoodItemByFoodIdSwapUsagesData,
  PostFoodItemByFoodIdSwapUsagesErrors,
  PostFoodItemByFoodIdSwapUsagesResponses,
  PostFoodItemByFoodIdTagByTagIdData,
  PostFoodItemByFoodIdTagByTagIdErrors,
  PostFoodItemByFoodIdTagByTagIdResponses,
  PostFoodItemByFoodIdTagsData,
  PostFoodItemByFoodIdTagsErrors,
  PostFoodItemByFoodIdTagsResponses,
  PostFoodRecipeData,
  PostFoodRecipeErrors,
  PostFoodRecipeResponses,
  PostFoodRecipeSearchData,
  PostFoodRecipeSearchErrors,
  PostFoodRecipeSearchResponses,
  PostFoodSupplierInfoInvoiceData,
  PostFoodSupplierInfoInvoiceErrors,
  PostFoodSupplierInfoInvoiceResponses,
  PostFoodTagByTagIdApplyData,
  PostFoodTagByTagIdApplyErrors,
  PostFoodTagByTagIdApplyResponses,
  PostFoodTagData,
  PostFoodTagErrors,
  PostFoodTagResponses,
  PostInventoryGfsOrderingFacilityData,
  PostInventoryGfsOrderingFacilityErrors,
  PostInventoryGfsOrderingFacilityResponses,
  PostInventoryGfsOrderingPurchasingAdjustData,
  PostInventoryGfsOrderingPurchasingAdjustErrors,
  PostInventoryGfsOrderingPurchasingAdjustResponses,
  PostInventoryGfsOrderingPurchasingOrderCsvData,
  PostInventoryGfsOrderingPurchasingOrderCsvErrors,
  PostInventoryGfsOrderingPurchasingOrderCsvResponses,
  PostInventoryGfsOrderingPurchasingRefreshData,
  PostInventoryGfsOrderingPurchasingRefreshErrors,
  PostInventoryGfsOrderingPurchasingRefreshResponses,
  PostInventoryGfsOrderingPurchasingUpdateInventoryData,
  PostInventoryGfsOrderingPurchasingUpdateInventoryErrors,
  PostInventoryGfsOrderingPurchasingUpdateInventoryResponses,
  PostInventoryPurchasingFromCustomMenusOnDatesData,
  PostInventoryPurchasingFromCustomMenusOnDatesErrors,
  PostInventoryPurchasingFromCustomMenusOnDatesResponses,
  PostInventoryPurchasingFromDateRangeData,
  PostInventoryPurchasingFromDateRangeErrors,
  PostInventoryPurchasingFromDateRangeResponses,
  PostInventoryPurchasingFromPortionOrdersData,
  PostInventoryPurchasingFromPortionOrdersErrors,
  PostInventoryPurchasingFromPortionOrdersResponses,
  PostInventoryStockDepletionData,
  PostInventoryStockDepletionErrors,
  PostInventoryStockDepletionResponses,
  PostInventoryStockReplenishmentData,
  PostInventoryStockReplenishmentErrors,
  PostInventoryStockReplenishmentResponses,
  PostInventoryStockReplenishmentSupplierOrderCsvFileData,
  PostInventoryStockReplenishmentSupplierOrderCsvFileErrors,
  PostInventoryStockReplenishmentSupplierOrderCsvFileResponses,
  PostMenuLoopByMenuLoopIdData,
  PostMenuLoopByMenuLoopIdErrors,
  PostMenuLoopByMenuLoopIdResponses,
  PostMenuLoopByMenuLoopIdSkipDateData,
  PostMenuLoopByMenuLoopIdSkipDateErrors,
  PostMenuLoopByMenuLoopIdSkipDateResponses,
  PostMenuLoopData,
  PostMenuLoopErrors,
  PostMenuLoopResponses,
  PostMenuLoopSearchData,
  PostMenuLoopSearchErrors,
  PostMenuLoopSearchResponses,
  PostMenuMealBatchData,
  PostMenuMealBatchErrors,
  PostMenuMealBatchResponses,
  PostMenuMealData,
  PostMenuMealErrors,
  PostMenuMealResponses,
  PostMenuMealSearchData,
  PostMenuMealSearchErrors,
  PostMenuMealSearchResponses,
  PostOrderMealData,
  PostOrderMealErrors,
  PostOrderMealResponses,
  PostUserAccountByUserIdPermissionByPermissionIdData,
  PostUserAccountByUserIdPermissionByPermissionIdErrors,
  PostUserAccountByUserIdPermissionByPermissionIdResponses,
  PostUserAccountData,
  PostUserAccountErrors,
  PostUserAccountResponses,
  PostUserGroupByGroupIdMembersByUserIdData,
  PostUserGroupByGroupIdMembersByUserIdErrors,
  PostUserGroupByGroupIdMembersByUserIdResponses,
  PostUserGroupByGroupIdPermissionByPermissionIdData,
  PostUserGroupByGroupIdPermissionByPermissionIdErrors,
  PostUserGroupByGroupIdPermissionByPermissionIdResponses,
  PostUserGroupData,
  PostUserGroupErrors,
  PostUserGroupResponses,
  PostUserPermissionData,
  PostUserPermissionErrors,
  PostUserPermissionResponses,
  PutAuthChangePasswordData,
  PutAuthChangePasswordErrors,
  PutAuthChangePasswordResponses,
  PutFoodGroupByGroupIdMembersData,
  PutFoodGroupByGroupIdMembersErrors,
  PutFoodGroupByGroupIdMembersResponses,
  PutInventoryGfsOrderingFacilityByProfileIdData,
  PutInventoryGfsOrderingFacilityByProfileIdErrors,
  PutInventoryGfsOrderingFacilityByProfileIdResponses,
  PutInventoryGfsOrderingFacilityIngredientLinkData,
  PutInventoryGfsOrderingFacilityIngredientLinkErrors,
  PutInventoryGfsOrderingFacilityIngredientLinkResponses,
  PutMenuMealByMenuIdData,
  PutMenuMealByMenuIdErrors,
  PutMenuMealByMenuIdResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

class HeyApiClient {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry<T> {
  private readonly defaultKey = "default";

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(
        `No SDK client found. Create one with "new JasperPlatformApiClient()" to fix this error.`,
      );
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

export class Authentication extends HeyApiClient {
  /**
   * Login For Access Token
   *
   * Get the access token (the login action)
   *
   * Returns:
   * Generated access token for a user along with the user account info and credential status.
   */
  public postAuthToken<ThrowOnError extends boolean = false>(
    options: Options<PostAuthTokenData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostAuthTokenResponses,
      PostAuthTokenErrors,
      ThrowOnError
    >({
      ...urlSearchParamsBodySerializer,
      responseType: "json",
      url: "/auth/token",
      ...options,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...options.headers,
      },
    });
  }

  /**
   * Change Password
   *
   * Enable user to change password
   */
  public putAuthChangePassword<ThrowOnError extends boolean = false>(
    options: Options<PutAuthChangePasswordData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).put<
      PutAuthChangePasswordResponses,
      PutAuthChangePasswordErrors,
      ThrowOnError
    >({
      ...urlSearchParamsBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/auth/change_password",
      ...options,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...options.headers,
      },
    });
  }

  /**
   * Request Password Reset
   *
   * Email a one-time password-reset link to the account's address.
   *
   * Always returns 202 whether or not the account exists, so the endpoint
   * cannot be used to enumerate accounts.
   */
  public postAuthPasswordResetRequest<ThrowOnError extends boolean = false>(
    options: Options<PostAuthPasswordResetRequestData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostAuthPasswordResetRequestResponses,
      PostAuthPasswordResetRequestErrors,
      ThrowOnError
    >({
      responseType: "json",
      url: "/auth/password_reset/request",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Confirm Password Reset
   *
   * Set a new password using a one-time reset token from the emailed link.
   *
   * All failure modes (unknown, cleared, or expired token) share one generic
   * 400 so the endpoint leaks nothing about which check failed.
   */
  public postAuthPasswordResetConfirm<ThrowOnError extends boolean = false>(
    options: Options<PostAuthPasswordResetConfirmData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostAuthPasswordResetConfirmResponses,
      PostAuthPasswordResetConfirmErrors,
      ThrowOnError
    >({
      responseType: "json",
      url: "/auth/password_reset/confirm",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class User extends HeyApiClient {
  /**
   * Create User Account
   *
   * Create new user account
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * new_user: The new user account data to create.
   * assign_group_ids: The user group ID this new user will assign to.
   * init_credential: The optional initial credential for account allow to sign in.
   * diet_profile: The optional diet profile for accounts that will place food orders.
   *
   * Returns:
   * The created user data.
   */
  public postUserAccount<ThrowOnError extends boolean = false>(
    options: Options<PostUserAccountData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostUserAccountResponses,
      PostUserAccountErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/account",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get User Account
   *
   * Load user account info by the user ID
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * user_id: The user's ID to fetch data.
   *
   * Returns:
   * The loaded user data.
   */
  public getUserAccountByUserId<ThrowOnError extends boolean = false>(
    options: Options<GetUserAccountByUserIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetUserAccountByUserIdResponses,
      GetUserAccountByUserIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/account/{user_id}",
      ...options,
    });
  }

  /**
   * Update User Account
   *
   * Update information in a user account
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * user_id: The user's ID to update.
   * updating_user_attributes: The attributes of the user to update.
   *
   * Returns:
   * The updated user data.
   */
  public patchUserAccountByUserId<ThrowOnError extends boolean = false>(
    options: Options<PatchUserAccountByUserIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).patch<
      PatchUserAccountByUserIdResponses,
      PatchUserAccountByUserIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/account/{user_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Create User Group
   *
   * Create a user group
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * new_user_group: The new user group data to create.
   *
   * Returns:
   * The created user group data.
   */
  public postUserGroup<ThrowOnError extends boolean = false>(
    options: Options<PostUserGroupData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostUserGroupResponses,
      PostUserGroupErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/group",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete User Group
   *
   * Delete a user group
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * group_id: The user group's ID to delete.
   *
   * Returns:
   * The deleted user group data.
   */
  public deleteUserGroupByGroupId<ThrowOnError extends boolean = false>(
    options: Options<DeleteUserGroupByGroupIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).delete<
      DeleteUserGroupByGroupIdResponses,
      DeleteUserGroupByGroupIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/group/{group_id}",
      ...options,
    });
  }

  /**
   * Get User Group
   *
   * Load a user group
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * group_id: The user group's ID to fetch data.
   *
   * Returns:
   * The loaded user group data.
   */
  public getUserGroupByGroupId<ThrowOnError extends boolean = false>(
    options: Options<GetUserGroupByGroupIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetUserGroupByGroupIdResponses,
      GetUserGroupByGroupIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/group/{group_id}",
      ...options,
    });
  }

  /**
   * Update User Group
   *
   * Update attributes for a user group
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * group_id: The user group's ID to update data.
   * updating_user_group_attributes: The attribute of the user group to update.
   *
   * Returns:
   * The updated user group data.
   */
  public patchUserGroupByGroupId<ThrowOnError extends boolean = false>(
    options: Options<PatchUserGroupByGroupIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).patch<
      PatchUserGroupByGroupIdResponses,
      PatchUserGroupByGroupIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/group/{group_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Search User Groups
   *
   * Search user groups by keywords in group name
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * keywords: The keywords to search food items.
   * number_per_page: The number of records in each page.
   * page_index: The page index (number) to load.
   * return_keys_only: Whether the endpoint only return list of user group keys (name and ID).
   *
   * Returns:
   * The list of user groups found.
   */
  public getUserGroupSearch<ThrowOnError extends boolean = false>(
    options?: Options<GetUserGroupSearchData, ThrowOnError>,
  ) {
    return (options?.client ?? this.client).get<
      GetUserGroupSearchResponses,
      GetUserGroupSearchErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/group/search",
      ...options,
    });
  }

  /**
   * Upsert Site Profile
   *
   * Upsert the site profile (timezone, menu_cycle_weeks) for a SITE group.
   *
   * If the group has no settings row yet, one is created using the provided
   * fields plus schema defaults for anything omitted. If a row already exists,
   * only the provided fields are updated.
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * group_id: The site user group's ID whose settings to upsert.
   * updating_settings: The settings fields to apply.
   *
   * Returns:
   * The updated user group with its site_profile populated.
   */
  public patchUserGroupByGroupIdProfile<ThrowOnError extends boolean = false>(
    options: Options<PatchUserGroupByGroupIdProfileData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).patch<
      PatchUserGroupByGroupIdProfileResponses,
      PatchUserGroupByGroupIdProfileErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/group/{group_id}/profile",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Remote Group Member
   *
   * Remote a user from a user group
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * group_id: The user group's ID to remove a member.
   * user_id: The user's ID going to be removed from the group.
   */
  public deleteUserGroupByGroupIdMembersByUserId<
    ThrowOnError extends boolean = false,
  >(
    options: Options<DeleteUserGroupByGroupIdMembersByUserIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).delete<
      DeleteUserGroupByGroupIdMembersByUserIdResponses,
      DeleteUserGroupByGroupIdMembersByUserIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/group/{group_id}/members/{user_id}",
      ...options,
    });
  }

  /**
   * Add Group Member
   *
   * Add a user to a user group
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * group_id: The user group's ID to add member.
   * user_id: The user's ID that become a new member of the group.
   */
  public postUserGroupByGroupIdMembersByUserId<
    ThrowOnError extends boolean = false,
  >(options: Options<PostUserGroupByGroupIdMembersByUserIdData, ThrowOnError>) {
    return (options.client ?? this.client).post<
      PostUserGroupByGroupIdMembersByUserIdResponses,
      PostUserGroupByGroupIdMembersByUserIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/group/{group_id}/members/{user_id}",
      ...options,
    });
  }

  /**
   * Create Permission
   *
   * Create a user permission
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * new_user_permission: The new user permission to create.
   *
   * Returns:
   * The created permission.
   */
  public postUserPermission<ThrowOnError extends boolean = false>(
    options: Options<PostUserPermissionData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostUserPermissionResponses,
      PostUserPermissionErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/permission",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Permission
   *
   * Delete a user permission
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * permission_id: The permission ID to delete.
   *
   * Returns:
   * The deleted permission.
   */
  public deleteUserPermissionByPermissionId<
    ThrowOnError extends boolean = false,
  >(options: Options<DeleteUserPermissionByPermissionIdData, ThrowOnError>) {
    return (options.client ?? this.client).delete<
      DeleteUserPermissionByPermissionIdResponses,
      DeleteUserPermissionByPermissionIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/permission/{permission_id}",
      ...options,
    });
  }

  /**
   * Get Permission
   *
   * Load a permission
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * permission_id: The ID of the permission to fetch.
   *
   * Returns:
   * The loaded permission data.
   */
  public getUserPermissionByPermissionId<ThrowOnError extends boolean = false>(
    options: Options<GetUserPermissionByPermissionIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetUserPermissionByPermissionIdResponses,
      GetUserPermissionByPermissionIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/permission/{permission_id}",
      ...options,
    });
  }

  /**
   * Update Permission
   *
   * Update attributes for a permission
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * permission_id: the permission ID used to reference the permission.
   * updating_permission_attributes: The permission attributes to update.
   *
   * Returns:
   * The updated permission data.
   */
  public patchUserPermissionByPermissionId<
    ThrowOnError extends boolean = false,
  >(options: Options<PatchUserPermissionByPermissionIdData, ThrowOnError>) {
    return (options.client ?? this.client).patch<
      PatchUserPermissionByPermissionIdResponses,
      PatchUserPermissionByPermissionIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/permission/{permission_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Remove Permission To User
   *
   * Remove permission from a user
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * user_id: The user to remove the permission from.
   * permission_id: the permission to remove.
   */
  public deleteUserAccountByUserIdPermissionByPermissionId<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      DeleteUserAccountByUserIdPermissionByPermissionIdData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).delete<
      DeleteUserAccountByUserIdPermissionByPermissionIdResponses,
      DeleteUserAccountByUserIdPermissionByPermissionIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/account/{user_id}/permission/{permission_id}",
      ...options,
    });
  }

  /**
   * Assign Permission To User
   *
   * Add a permission to a user
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * user_id: The user to assign the permission.
   * permission_id: The permission ID assigning to the user.
   */
  public postUserAccountByUserIdPermissionByPermissionId<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      PostUserAccountByUserIdPermissionByPermissionIdData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).post<
      PostUserAccountByUserIdPermissionByPermissionIdResponses,
      PostUserAccountByUserIdPermissionByPermissionIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/account/{user_id}/permission/{permission_id}",
      ...options,
    });
  }

  /**
   * Remove Permission To Group
   *
   * Remove a permission from a group
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * group_id: The group to remove the permission from.
   * permission_id: the permission to remove.
   */
  public deleteUserGroupByGroupIdPermissionByPermissionId<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      DeleteUserGroupByGroupIdPermissionByPermissionIdData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).delete<
      DeleteUserGroupByGroupIdPermissionByPermissionIdResponses,
      DeleteUserGroupByGroupIdPermissionByPermissionIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/group/{group_id}/permission/{permission_id}",
      ...options,
    });
  }

  /**
   * Assign Permission To Group
   *
   * Add a permission to a group
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * group_id: the group to assign the permission.
   * permission_id: the permission to assign to the group.
   */
  public postUserGroupByGroupIdPermissionByPermissionId<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      PostUserGroupByGroupIdPermissionByPermissionIdData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).post<
      PostUserGroupByGroupIdPermissionByPermissionIdResponses,
      PostUserGroupByGroupIdPermissionByPermissionIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/user/group/{group_id}/permission/{permission_id}",
      ...options,
    });
  }
}

export class DietProfile extends HeyApiClient {
  /**
   * Get All User Diet Profile In Group
   *
   * Get all user diet profiles in a group or multiple composite groups
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * group_ids: Intersecting user group IDs to query all user diet profiles in.
   *
   * Returns:
   * List of loaded user diet profiles in the target group.
   */
  public getDietProfileInGroup<ThrowOnError extends boolean = false>(
    options?: Options<GetDietProfileInGroupData, ThrowOnError>,
  ) {
    return (options?.client ?? this.client).get<
      GetDietProfileInGroupResponses,
      GetDietProfileInGroupErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/diet_profile/in_group",
      ...options,
    });
  }

  /**
   * Get User Diet Profile
   *
   * Get user diet profile by user ID
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * user_id: User ID to query diet profile.
   *
   * Returns:
   * The diet profile associated with the user with ID.
   */
  public getDietProfileByUserId<ThrowOnError extends boolean = false>(
    options: Options<GetDietProfileByUserIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetDietProfileByUserIdResponses,
      GetDietProfileByUserIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/diet_profile/{user_id}",
      ...options,
    });
  }

  /**
   * Update User Diet Profile
   *
   * Update a user diet profile
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * user_id: User's ID to create diet profile for.
   * updating_user_diet_profile_attributes: The user diet profile data to update.
   * updating_user_attributes: The optional attributes of the user to update.
   *
   * Returns:
   * The diet profile updated for the user with ID.
   */
  public patchDietProfileByUserId<ThrowOnError extends boolean = false>(
    options: Options<PatchDietProfileByUserIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).patch<
      PatchDietProfileByUserIdResponses,
      PatchDietProfileByUserIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/diet_profile/{user_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Create User Diet Profile
   *
   * Create a user diet profile
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * user_id: User's ID to create diet profile for.
   * new_user_diet_profile: The user diet profile data to create.
   *
   * Returns:
   * The diet profile created for the user with ID.
   */
  public postDietProfileByUserId<ThrowOnError extends boolean = false>(
    options: Options<PostDietProfileByUserIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostDietProfileByUserIdResponses,
      PostDietProfileByUserIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/diet_profile/{user_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class FoodTag extends HeyApiClient {
  /**
   * Create Food Tag
   *
   * Create new food tag
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * food_tag: The new tag to create.
   * additional_keywords: Optional list of additional keywords to consider for auto-tagging.
   * tag_categories_to_update: Optional list of tag categories to consider for auto-tagging.
   *
   * Returns:
   * The new food tag and the list of food item IDs that were tagged.
   */
  public postFoodTag<ThrowOnError extends boolean = false>(
    options: Options<PostFoodTagData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostFoodTagResponses,
      PostFoodTagErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/tag",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Apply Existing Tag To All Ingredients
   *
   * Apply an existing tag (by id) to all ingredients on the platform.
   *
   * Args:
   * tag_id: ID of the existing tag to apply.
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * additional_keywords: Optional list of additional keywords to consider for auto-tagging.
   * tag_categories_to_update: Optional list of tag categories to consider for auto-tagging.
   *
   * Returns:
   * The existing food tag that was applied and the list of food item IDs that were tagged.
   */
  public postFoodTagByTagIdApply<ThrowOnError extends boolean = false>(
    options: Options<PostFoodTagByTagIdApplyData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostFoodTagByTagIdApplyResponses,
      PostFoodTagByTagIdApplyErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/tag/{tag_id}/apply",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Food Tag
   *
   * Delete a food tag
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * tag_id: The food tag ID to delete.
   *
   * Returns:
   * The deleted food tag.
   */
  public deleteFoodTagByTagId<ThrowOnError extends boolean = false>(
    options: Options<DeleteFoodTagByTagIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).delete<
      DeleteFoodTagByTagIdResponses,
      DeleteFoodTagByTagIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/tag/{tag_id}",
      ...options,
    });
  }

  /**
   * Get Food Tag
   *
   * Get food tag by ID
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * tag_id: Food tag ID to query.
   *
   * Returns:
   * The loaded food tag.
   */
  public getFoodTagByTagId<ThrowOnError extends boolean = false>(
    options: Options<GetFoodTagByTagIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetFoodTagByTagIdResponses,
      GetFoodTagByTagIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/tag/{tag_id}",
      ...options,
    });
  }

  /**
   * Update Food Tag
   *
   * Update a food tag
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * tag_id: The food tag ID to update.
   * food_tag: The attributes of food tag to update.
   *
   * Returns:
   * Updated food tag.
   */
  public patchFoodTagByTagId<ThrowOnError extends boolean = false>(
    options: Options<PatchFoodTagByTagIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).patch<
      PatchFoodTagByTagIdResponses,
      PatchFoodTagByTagIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/tag/{tag_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Food Tag All
   *
   * Get all food tag
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   *
   * Returns:
   * A list of loaded food tags.
   */
  public getFoodTagAll<ThrowOnError extends boolean = false>(
    options?: Options<GetFoodTagAllData, ThrowOnError>,
  ) {
    return (options?.client ?? this.client).get<
      GetFoodTagAllResponses,
      GetFoodTagAllErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/tag/all",
      ...options,
    });
  }
}

export class FoodItem extends HeyApiClient {
  /**
   * Update Food Item Approval State
   *
   * Approve or disapprove a food item
   *
   * Args:
   * authorized_user: The authorized user doing the approval.
   * db_session: The database session to use for this endpoint call.
   * food_id: The ID of the food item to approve.
   * approving_roles:
   * Optional roles that are doing the approval. Useful for users with
   * multiple roles but only want to approve a food item as one or a
   * subset of his roles.
   * disapproval: Optional flag for action to disapprove a food item.
   *
   * Returns:
   * Approved food item.
   */
  public postFoodItemApprovalByFoodId<ThrowOnError extends boolean = false>(
    options: Options<PostFoodItemApprovalByFoodIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostFoodItemApprovalByFoodIdResponses,
      PostFoodItemApprovalByFoodIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/item/approval/{food_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Swap Food Item Usages
   *
   * Swap every live usage of this food to another food.
   *
   * Live usages are ingredient steps of activated recipes and menu items on
   * templates, future menus, or menus linked to a not-yet-ended menu loop.
   * Deactivated recipes and standalone past menus keep the old food — they
   * are history. The target's own recipe also keeps the source as its
   * ingredient (repointing it would create a self-reference).
   *
   * This endpoint swaps only — it never deactivates the source. Deactivation
   * is a separate step via the existing food-item update endpoint, whose
   * guard reports anything still using the food (e.g. the target's own
   * recipe keeping the source).
   *
   * Args:
   * authorized_user: The authorized user issuing the swap.
   * db_session: The database session to use for this endpoint call.
   * food_id: The source food whose usages are swapped away.
   * swap_request: Carries ``target_food_id``, the replacement food.
   *
   * Returns:
   * A report of what was swapped, per usage category.
   */
  public postFoodItemByFoodIdSwapUsages<ThrowOnError extends boolean = false>(
    options: Options<PostFoodItemByFoodIdSwapUsagesData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostFoodItemByFoodIdSwapUsagesResponses,
      PostFoodItemByFoodIdSwapUsagesErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/item/{food_id}/swap_usages",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Food Item
   *
   * Load a food item
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * food_id: The ID of the food item to load.
   * return_keys_only: Whether the endpoint only return food item keys (name and ID).
   * return_type:
   * Options of the return types,
   * 1. food and equivalent foods
   * 2. food and variant foods
   * 3. food and related foods (both variants and equivalents)
   * 4. food and usages
   * 5. food
   * 6. food key
   * Default to return food item objects.
   *
   * Returns:
   * Loaded food item.
   */
  public getFoodItemByFoodId<ThrowOnError extends boolean = false>(
    options: Options<GetFoodItemByFoodIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetFoodItemByFoodIdResponses,
      GetFoodItemByFoodIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/item/{food_id}",
      ...options,
    });
  }

  /**
   * Read Food Item Effective Tags
   *
   * Read the tags a food effectively carries under enrichment settings
   *
   * Previews what a menu item linked to this food reports as ``food_tags``
   * under the same settings the menu reads accept: an explicit equivalent
   * selection and/or a target site whose supplier selection is resolved
   * from its supply profiles (explicit entries win per group). An optional
   * body of menu-level overrides is validated against the food's own tags
   * and applied on top; ``removable_tags`` lists the food's own tags a chef
   * may hide, whatever the body.
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * food_id: The ID of the food item to read.
   * enrichment_params:
   * Query params: ``equivalent_selection`` JSON string and
   * ``for_site_id``. Site-locked accounts may only name their own
   * sites.
   * body: Optional overrides to preview.
   *
   * Raises:
   * HTTPException: 400 unknown food; 403 foreign site; 422 invalid
   * equivalent selection or an override the policy rejects.
   *
   * Returns:
   * The food's effective tags and its removable tags.
   */
  public postFoodItemByFoodIdTags<ThrowOnError extends boolean = false>(
    options: Options<PostFoodItemByFoodIdTagsData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostFoodItemByFoodIdTagsResponses,
      PostFoodItemByFoodIdTagsErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/item/{food_id}/tags",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get List Of Food Items
   *
   * Get list of food items
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * food_ids: The food item IDs to get list of FoodItems.
   * return_keys_only: Whether the endpoint only return food item keys (name and ID).
   * return_type:
   * Options of the return types,
   * 1. food and equivalent foods
   * 2. food and variant foods
   * 3. food and related foods (both variants and equivalents)
   * 4. food and usages
   * 5. food
   * 6. food key
   * Default to return food item objects. Augmented return types
   * ("food and ..." options) are read per food ID and may be
   * significantly slower than the default for large lists.
   *
   * Returns:
   * The list of loaded food items.
   */
  public getFoodItems<ThrowOnError extends boolean = false>(
    options: Options<GetFoodItemsData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetFoodItemsResponses,
      GetFoodItemsErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/items",
      ...options,
    });
  }

  /**
   * Download List Of Food Items
   *
   * Download a list of food items
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * food_ids: The food item IDs to download or leave it empty to download all.
   *
   * Returns:
   * The list of loaded food items.
   */
  public getFoodItemsDownload<ThrowOnError extends boolean = false>(
    options?: Options<GetFoodItemsDownloadData, ThrowOnError>,
  ) {
    return (options?.client ?? this.client).get<
      GetFoodItemsDownloadResponses,
      GetFoodItemsDownloadErrors,
      ThrowOnError
    >({
      responseType: "blob",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/items/download",
      ...options,
    });
  }

  /**
   * Search Food Items
   *
   * Search food item in the system
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * keywords: The keywords to search food items.
   * number_per_page: The number of records in each page.
   * page_index: The page index (number) to load.
   * return_keys_only: Whether the endpoint only return list of food item keys (name and ID).
   * only_procured_items: Optional flag to only search on items brought from suppliers.
   * only_updated_after:
   * Optional flag to only return items updated after this timestamp.
   * Expect tz-aware object.
   * return_type:
   * Options of the return types supported by search,
   * 1. food and related foods (each match plus its variant siblings
   * and is_food-tag equivalents)
   * 2. food
   * 3. food key
   * Defaults to plain food items. The "food and related foods" shape is
   * assembled per match and may be slower than the default for large
   * result sets. A bare call (no filter params) ignores this option and
   * returns the full cache as "food and related foods".
   *
   * Returns:
   * List of food items found.
   */
  public getFoodItemSearch<ThrowOnError extends boolean = false>(
    options?: Options<GetFoodItemSearchData, ThrowOnError>,
  ) {
    return (options?.client ?? this.client).get<
      GetFoodItemSearchResponses,
      GetFoodItemSearchErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/item/search",
      ...options,
    });
  }

  /**
   * Remove Food Item Tag
   *
   * Remove a food tag from a food item
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * food_id: The ID of the food item to remove tag.
   * tag_id: The ID of the tag to remove.
   */
  public deleteFoodItemByFoodIdTagByTagId<ThrowOnError extends boolean = false>(
    options: Options<DeleteFoodItemByFoodIdTagByTagIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).delete<
      DeleteFoodItemByFoodIdTagByTagIdResponses,
      DeleteFoodItemByFoodIdTagByTagIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/item/{food_id}/tag/{tag_id}",
      ...options,
    });
  }

  /**
   * Add Food Item Tag
   *
   * Append a food tag to a food item
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * food_id: The ID of the food item to add tag.
   * tag_id: The ID of the tag to add.
   */
  public postFoodItemByFoodIdTagByTagId<ThrowOnError extends boolean = false>(
    options: Options<PostFoodItemByFoodIdTagByTagIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostFoodItemByFoodIdTagByTagIdResponses,
      PostFoodItemByFoodIdTagByTagIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/item/{food_id}/tag/{tag_id}",
      ...options,
    });
  }

  /**
   * Batch Edit Food Item Tags
   *
   * Batch add/remove food tags across many food items.
   *
   * Each item's adds and removes are applied atomically and idempotently
   * (adding a present tag or removing an absent tag is a no-op). Items fail
   * independently — a bad item reports its error in the matching result
   * without failing the request or blocking other items. An edit that would
   * add or remove a variant-identity tag link is rejected per item. Every
   * food that actually changed gets its ``updated_at`` bumped (so clients
   * syncing with ``only_updated_after`` pick up the change), a data-change
   * log entry, and a cache refresh.
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * batch_request: The per-food tag edits to apply.
   *
   * Returns:
   * One result per requested item, in request order.
   */
  public patchFoodItemsTags<ThrowOnError extends boolean = false>(
    options: Options<PatchFoodItemsTagsData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).patch<
      PatchFoodItemsTagsResponses,
      PatchFoodItemsTagsErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/items/tags",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class FoodGroup extends HeyApiClient {
  /**
   * Get List Of Food Groups
   *
   * Read food groups, optionally filtered
   *
   * Args:
   * db_session: The database session to use for this endpoint call.
   * group_type: Optional group type to filter on.
   * group_name_contains:
   * Optional case-insensitive substring the group name must contain.
   *
   * Returns:
   * Food groups matching the filters.
   */
  public getFoodGroup<ThrowOnError extends boolean = false>(
    options?: Options<GetFoodGroupData, ThrowOnError>,
  ) {
    return (options?.client ?? this.client).get<
      GetFoodGroupResponses,
      GetFoodGroupErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/group",
      ...options,
    });
  }

  /**
   * Create Food Group
   *
   * Create a new food group
   *
   * Args:
   * authorized_user: The authorized user creating the group.
   * db_session: The database session to use for this endpoint call.
   * food_group: The new food group to create.
   *
   * Returns:
   * Created food group.
   */
  public postFoodGroup<ThrowOnError extends boolean = false>(
    options: Options<PostFoodGroupData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostFoodGroupResponses,
      PostFoodGroupErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/group",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Delete Food Group
   *
   * Delete a food group
   *
   * Deleting a group cascades to its member links; the member foods
   * themselves are untouched. Former members' cache entries are refreshed
   * so they stop carrying the deleted group.
   *
   * Args:
   * authorized_user: The authorized user deleting the group.
   * db_session: The database session to use for this endpoint call.
   * group_id: The group ID of the food group to delete.
   *
   * Returns:
   * Deleted food group.
   */
  public deleteFoodGroupByGroupId<ThrowOnError extends boolean = false>(
    options: Options<DeleteFoodGroupByGroupIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).delete<
      DeleteFoodGroupByGroupIdResponses,
      DeleteFoodGroupByGroupIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/group/{group_id}",
      ...options,
    });
  }

  /**
   * Get Food Group
   *
   * Read a food group with its member foods
   *
   * Each member carries the user groups (sites) it is linked to, so the
   * caller can render the per-site versions of the dish from one call.
   *
   * Args:
   * db_session: The database session to use for this endpoint call.
   * group_id: The group ID of the food group to read.
   *
   * Returns:
   * The food group with its members.
   */
  public getFoodGroupByGroupId<ThrowOnError extends boolean = false>(
    options: Options<GetFoodGroupByGroupIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetFoodGroupByGroupIdResponses,
      GetFoodGroupByGroupIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/group/{group_id}",
      ...options,
    });
  }

  /**
   * Update Food Group
   *
   * Update (rename) a food group
   *
   * The cached read model of every member food carries the group name, so a
   * rename refreshes all current members' cache entries.
   *
   * Args:
   * authorized_user: The authorized user updating the group.
   * db_session: The database session to use for this endpoint call.
   * group_id: The group ID of the food group to update.
   * food_group: The food group fields to update.
   *
   * Returns:
   * Updated food group.
   */
  public patchFoodGroupByGroupId<ThrowOnError extends boolean = false>(
    options: Options<PatchFoodGroupByGroupIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).patch<
      PatchFoodGroupByGroupIdResponses,
      PatchFoodGroupByGroupIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/group/{group_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Sync Food Group Members
   *
   * Sync a food group's members to an exact set of foods
   *
   * Converges the group's member links to exactly ``food_ids``: missing
   * links are created and links to any other food are removed. Idempotent;
   * an empty set clears the group. Every referenced food must exist —
   * nothing is written otherwise. Only foods whose membership actually
   * changed (added or removed) get their cache entries refreshed.
   *
   * Args:
   * authorized_user: The authorized user syncing the members.
   * db_session: The database session to use for this endpoint call.
   * group_id: The group ID of the food group to sync members for.
   * members_request: Carries ``food_ids``, the complete target membership.
   *
   * Returns:
   * The food group with its synced members.
   */
  public putFoodGroupByGroupIdMembers<ThrowOnError extends boolean = false>(
    options: Options<PutFoodGroupByGroupIdMembersData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).put<
      PutFoodGroupByGroupIdMembersResponses,
      PutFoodGroupByGroupIdMembersErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/group/{group_id}/members",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class Ingredient extends HeyApiClient {
  /**
   * Create Ingredient
   *
   * Create a new ingredient
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * ingredient: The basic information of the new food item to create.
   * supplier_info: The supplier information of the new ingredient.
   * nutrition_facts: The nutrition facts record of the new ingredient.
   * food_item_tags: The list of food item tag to create for the new ingredient.
   * equivalent_ingredients:
   * Optional list of equivalent ingredients to create together with the main ingredient.
   * They share the same basic food item information as the main ingredient and only
   * their supplier info, nutrition facts, and food tags are used.
   * user_group_ids:
   * Optional user group IDs to link the new ingredient to. Applies to
   * the main ingredient only — equivalents are created unlinked.
   *
   * Returns:
   * Created ingredient (food item with supplier information)
   * with equivalent ingredients if provided.
   */
  public postFoodIng<ThrowOnError extends boolean = false>(
    options: Options<PostFoodIngData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostFoodIngResponses,
      PostFoodIngErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/ing",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Update Ingredient
   *
   * Update an ingredient
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * food_id: The food ID of ingredient to update.
   * ingredient: The basic information of the new food item to update.
   * supplier_info: The supplier information of the ingredient to update.
   * nutrition_facts: The nutrition facts record of the ingredient to update.
   * food_item_tags: The list of food item tag update to the ingredient.
   * equivalent_ingredients:
   * Optional list of equivalent ingredient changes in batch.
   * Supports both update objects (FoodItemUpdateDeepInBatch) and create objects
   * (FoodItemIngredientCreateDeep). None means no equivalent change. Empty list means remove
   * all existing equivalent ingredients.
   * user_group_ids:
   * Optional user group IDs to sync the ingredient's links to. None
   * leaves the links untouched; a set (possibly empty) syncs to
   * exactly that set. Applies to the main ingredient only.
   *
   * Returns:
   * Updated ingredient with equivalent ingredients if provided.
   */
  public patchFoodIngByFoodId<ThrowOnError extends boolean = false>(
    options: Options<PatchFoodIngByFoodIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).patch<
      PatchFoodIngByFoodIdResponses,
      PatchFoodIngByFoodIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/ing/{food_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Auto Tagging
   *
   * Auto tagging from the uploaded csv.
   *
   * In dry‑run mode, returns a ZIP file containing two CSVs (for chef and developer).
   * Otherwise, initiates the tagging process and returns None.
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * csv_file: csv from the GFS scrapper code.
   * csv_gfs_categories: GFS categories rule csv.
   * csv_rule_df: Ingredient rule csv.
   * supplier_name: Name of the supplier.
   * dry_run: If True, generate and return CSVs in a ZIP.
   * If False, apply tags.
   *
   * Returns:
   * A ZIP file containing chef/developer CSVs when `dry_run` is True.
   * Otherwise, return None and updates the database.
   */
  public postFoodIngGfsScrapperCsv<ThrowOnError extends boolean = false>(
    options: Options<PostFoodIngGfsScrapperCsvData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostFoodIngGfsScrapperCsvResponses,
      PostFoodIngGfsScrapperCsvErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/ing/gfs_scrapper_csv",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });
  }

  /**
   * Invoice Batch Update Supplier Info
   *
   * Extract updated and TBD list of invoice records from uploaded supplier invoice CSV file
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * invoice_csv_file: The uploaded invoice CSV file
   * supplier_name: Name of the supplier.
   *
   * Returns:
   * List of GFS invoice records, list of resolved foods to update.
   */
  public postFoodSupplierInfoInvoice<ThrowOnError extends boolean = false>(
    options: Options<PostFoodSupplierInfoInvoiceData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostFoodSupplierInfoInvoiceResponses,
      PostFoodSupplierInfoInvoiceErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/supplier_info/invoice",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });
  }

  /**
   * Lookup Supplier Info By Product Code
   *
   * Look up active foods that already use a given supplier product code.
   *
   * Used by the ingredient edit form to surface duplicate product codes on
   * blur. Results follow the same grouping as ``db_search_food_item``:
   * each is_food twin group collapses to its representative (the
   * smallest-id active original), so a single match on any group member
   * surfaces the group's rep — never a non-rep equivalent or a variant.
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * product_code: Product code to match exactly.
   * exclude_food_id:
   * Optional food ID to suppress. The edit form passes the food
   * being edited so it doesn't flag itself. Suppression applies
   * to the whole is_food group: passing any member (the rep, or
   * a non-rep equivalent) drops the group's rep entry.
   *
   * Returns:
   * List of conflicting foods (one entry per group, identified by
   * the rep's ``id`` and ``food_name``). Empty list means no
   * conflict.
   */
  public getFoodSupplierInfoLookup<ThrowOnError extends boolean = false>(
    options: Options<GetFoodSupplierInfoLookupData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetFoodSupplierInfoLookupResponses,
      GetFoodSupplierInfoLookupErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/supplier_info/lookup",
      ...options,
    });
  }
}

export class Recipe extends HeyApiClient {
  /**
   * Search Food Recipes
   *
   * Search food recipe in the system
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * keywords: The keywords to search food recipe.
   * number_per_page: The number of records in each page.
   * page_index: The page index (number) to load.
   * return_keys_only: Whether the endpoint only return list of food recipe keys
   * (name, ID, food ID, and food name).
   *
   * Returns:
   * List of food recipes found.
   */
  public getFoodRecipeSearch<ThrowOnError extends boolean = false>(
    options?: Options<GetFoodRecipeSearchData, ThrowOnError>,
  ) {
    return (options?.client ?? this.client).get<
      GetFoodRecipeSearchResponses,
      GetFoodRecipeSearchErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/recipe/search",
      ...options,
    });
  }

  /**
   * Advance Search Food Recipes
   *
   * Advance search food recipe in the system
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * params: The parameters to search food recipe.
   * number_per_page: The number of records in each page.
   * page_index: The page index (number) to load.
   * return_keys_only: Whether the endpoint only return list of food recipe keys
   * (name, ID, food ID, and food name).
   *
   * Returns:
   * List of food recipes found.
   */
  public postFoodRecipeSearch<ThrowOnError extends boolean = false>(
    options?: Options<PostFoodRecipeSearchData, ThrowOnError>,
  ) {
    return (options?.client ?? this.client).post<
      PostFoodRecipeSearchResponses,
      PostFoodRecipeSearchErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/recipe/search",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });
  }

  /**
   * Deep Create Recipe
   *
   * Deep create a new recipe (optionally with variants in the same call).
   *
   * The whole creation runs in a single transaction. If anything fails
   * (validation or persistence) the entire operation is rolled back — main
   * and any in-flight variants alike.
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * dish_info: The basic information of the dish of new recipe to create.
   * recipe: The new recipe data to create.
   * food_item_tags: The list of food item tag use for the new recipe.
   * variants: Optional list of variant recipes to create together with the
   * main recipe. Each variant carries its own dish info, recipe, and
   * recipe-level tags. Variants point to the just-created main via
   * ``original_food_id`` (server-managed) and may share the main's
   * food name (variant name uniqueness is not enforced).
   * user_group_ids:
   * Optional user group IDs to link the new recipe to. Applies to the
   * main recipe only — variants carry their own ``user_group_ids``.
   *
   * Returns:
   * Created main recipe with any created variants attached.
   */
  public postFoodRecipe<ThrowOnError extends boolean = false>(
    options: Options<PostFoodRecipeData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostFoodRecipeResponses,
      PostFoodRecipeErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/recipe",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Deep Update Recipe
   *
   * Deep update a recipe (optionally with variants in the same call).
   *
   * The whole update runs in a single transaction. If anything fails
   * (validation or persistence) the entire operation is rolled back — main
   * and any variant changes alike.
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * food_id: The food's ID to update recipe.
   * recipe_id: The food's specific recipe ID to update.
   * dish_info: The attributes of the basic dish information (food item) to update.
   * recipe: The attributes of the recipe data to update.
   * food_item_tags: The list of food item tag use for the updating recipe.
   * variants: Optional list of variant changes.
   * ``FoodItemUpdateDeepInBatch`` entries update existing
   * variants by id; ``FoodItemRecipeCreateDeep`` entries create new
   * variants linked to this food. ``None`` keeps existing variants
   * untouched but still propagates the main basic-info update to
   * them. ``[]`` removes all existing variants.
   * user_group_ids:
   * Optional user group IDs to sync the recipe's links to. None
   * leaves the links untouched; a set (possibly empty) syncs to
   * exactly that set. Applies to the main recipe only.
   *
   * Returns:
   * Updated recipe with its variants.
   */
  public patchFoodItemByFoodIdRecipeByRecipeId<
    ThrowOnError extends boolean = false,
  >(options: Options<PatchFoodItemByFoodIdRecipeByRecipeIdData, ThrowOnError>) {
    return (options.client ?? this.client).patch<
      PatchFoodItemByFoodIdRecipeByRecipeIdResponses,
      PatchFoodItemByFoodIdRecipeByRecipeIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/food/item/{food_id}/recipe/{recipe_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class Menu extends HeyApiClient {
  /**
   * Download Daily Menus
   *
   * Load menus at a specific query date and download the detail breakdown
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * query_date: The date to download menus.
   *
   * Returns:
   * CSV file of menus breakdown on the target query date.
   */
  public getMenuDailyByQueryDateDownload<ThrowOnError extends boolean = false>(
    options: Options<GetMenuDailyByQueryDateDownloadData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetMenuDailyByQueryDateDownloadResponses,
      GetMenuDailyByQueryDateDownloadErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/daily/{query_date}/download",
      ...options,
    });
  }

  /**
   * Get Daily Menus
   *
   * Load menus at a specific query date
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * query_date: The date to load menus.
   * enrichment_params:
   * Query params controlling which enrichment steps run, including the
   * optional equivalent_selection JSON string.
   * filtering_params:
   * Query params filtering which menus return: ``for_site_id`` narrows
   * to one site (site-locked accounts may only name their own sites)
   * and also drives auto-resolution as that site; ``menu_type``
   * selects which cycle category unwraps into previews (default: all).
   * auto_resolve_equivalent_selection:
   * Auto-resolve the equivalent supplier selection per menu site (its
   * supply profiles). Explicit equivalent_selection entries override
   * auto-resolved ones per group. Also activated by ``for_site_id``,
   * which then resolves every menu as that site.
   *
   * Returns:
   * Loaded menus on the target query date.
   */
  public getMenuDailyByQueryDate<ThrowOnError extends boolean = false>(
    options: Options<GetMenuDailyByQueryDateData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetMenuDailyByQueryDateResponses,
      GetMenuDailyByQueryDateErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/daily/{query_date}",
      ...options,
    });
  }

  /**
   * Get Menus In Date Range
   *
   * Load menus at a specific query date range
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * date_start: The start date range to load menus inclusive.
   * date_end: The end date range to load menus inclusive.
   * tz_info_str: The optional timezone information. Default to server's timezone.
   * enrichment_params:
   * Query params controlling which enrichment steps run, including the
   * optional equivalent_selection JSON string.
   * filtering_params:
   * Query params filtering which menus return: ``for_site_id`` narrows
   * to one site (site-locked accounts may only name their own sites)
   * and also drives auto-resolution as that site; ``menu_type``
   * selects which cycle category unwraps into previews (default:
   * regular cycle menus, this endpoint's historical behavior).
   * auto_resolve_equivalent_selection:
   * Auto-resolve the equivalent supplier selection per menu site (its
   * supply profiles). Explicit equivalent_selection entries override
   * auto-resolved ones per group. Also activated by ``for_site_id``,
   * which then resolves every menu as that site.
   *
   * Returns:
   * Loaded menus on the target query date range.
   */
  public getMenuDateRangeFromByDateStartToByDateEnd<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      GetMenuDateRangeFromByDateStartToByDateEndData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).get<
      GetMenuDateRangeFromByDateStartToByDateEndResponses,
      GetMenuDateRangeFromByDateStartToByDateEndErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/date_range/from/{date_start}/to/{date_end}",
      ...options,
    });
  }

  /**
   * Search Menus
   *
   * Search meal menu in the system
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * keywords: The keywords to search in menu name.
   * number_per_page: The number of records in each page.
   * page_index: The page index (number) to load.
   * return_keys_only: Whether the endpoint only return list of menu basic
   * (menu without sections data).
   *
   * Returns:
   * List of menus found.
   */
  public getMenuMealSearch<ThrowOnError extends boolean = false>(
    options?: Options<GetMenuMealSearchData, ThrowOnError>,
  ) {
    return (options?.client ?? this.client).get<
      GetMenuMealSearchResponses,
      GetMenuMealSearchErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/meal/search",
      ...options,
    });
  }

  /**
   * Advance Search Menus
   *
   * Advance search meal menu in the system
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * params: The advance parameters to search menu in system.
   * number_per_page: The number of records in each page.
   * page_index: The page index (number) to load.
   * return_keys_only: Whether the endpoint only return list of menu basic
   * (menu without sections data).
   *
   * Returns:
   * List of menus found.
   */
  public postMenuMealSearch<ThrowOnError extends boolean = false>(
    options?: Options<PostMenuMealSearchData, ThrowOnError>,
  ) {
    return (options?.client ?? this.client).post<
      PostMenuMealSearchResponses,
      PostMenuMealSearchErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/meal/search",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Menu
   *
   * Delete a menu
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * menu_id: The menu ID to delete.
   *
   * Returns:
   * Deleted menu
   */
  public deleteMenuMealByMenuId<ThrowOnError extends boolean = false>(
    options: Options<DeleteMenuMealByMenuIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).delete<
      DeleteMenuMealByMenuIdResponses,
      DeleteMenuMealByMenuIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/meal/{menu_id}",
      ...options,
    });
  }

  /**
   * Get Menu
   *
   * Load a menu by ID
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * menu_id: The menu ID to load.
   * enrichment_params:
   * Query params controlling which enrichment steps run, including the
   * optional equivalent_selection JSON string.
   * auto_resolve_equivalent_selection:
   * Auto-resolve the equivalent supplier selection from THE menu's
   * site (its supply profiles). Single-menu semantics, so the flag
   * lives on this endpoint only, not on the shared enrichment params.
   * Explicit equivalent_selection entries override auto-resolved ones
   * per group.
   * equivalent_selection_site_id:
   * Auto-resolve the selection for THIS site instead - the way to
   * enrich a site-less (any-site) menu as a specific site would see
   * it. Providing it activates auto-resolution on its own and takes
   * precedence over the menu's own site when both params are given.
   *
   * Returns:
   * Loaded menu.
   */
  public getMenuMealByMenuId<ThrowOnError extends boolean = false>(
    options: Options<GetMenuMealByMenuIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetMenuMealByMenuIdResponses,
      GetMenuMealByMenuIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/meal/{menu_id}",
      ...options,
    });
  }

  /**
   * Deep Update Menu
   *
   * Deep update a menu
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * menu_id: The menu ID to update.
   * menu: The menu fields to update.
   *
   * Returns:
   * Updated menu.
   */
  public putMenuMealByMenuId<ThrowOnError extends boolean = false>(
    options: Options<PutMenuMealByMenuIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).put<
      PutMenuMealByMenuIdResponses,
      PutMenuMealByMenuIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/meal/{menu_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Deep Create Menu
   *
   * Deep create menu
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * menu: The menu to create.
   *
   * Returns:
   * Created menu.
   */
  public postMenuMeal<ThrowOnError extends boolean = false>(
    options: Options<PostMenuMealData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostMenuMealResponses,
      PostMenuMealErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/meal",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Deep Update Menus
   *
   * Deep update a list of menus
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * menus: The menus fields to update.
   *
   * Returns:
   * Updated menus.
   */
  public patchMenuMealBatch<ThrowOnError extends boolean = false>(
    options: Options<PatchMenuMealBatchData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).patch<
      PatchMenuMealBatchResponses,
      PatchMenuMealBatchErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/meal/batch",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Deep Create Menus
   *
   * Deep create list of menus
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * menus: The menus to create.
   *
   * Returns:
   * Created menus.
   */
  public postMenuMealBatch<ThrowOnError extends boolean = false>(
    options: Options<PostMenuMealBatchData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostMenuMealBatchResponses,
      PostMenuMealBatchErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/meal/batch",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class MenuLoop extends HeyApiClient {
  /**
   * Search Menu Loop
   *
   * Search menu loop in the system
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * keywords: The keywords to search in menu loop name.
   * number_per_page: The number of records in each page.
   * page_index: The page index (number) to load.
   * return_keys_only: Whether the endpoint only return list of menu loop basic
   * (menu loop without menus in loop data).
   *
   * Returns:
   * List of menu loops found.
   */
  public getMenuLoopSearch<ThrowOnError extends boolean = false>(
    options?: Options<GetMenuLoopSearchData, ThrowOnError>,
  ) {
    return (options?.client ?? this.client).get<
      GetMenuLoopSearchResponses,
      GetMenuLoopSearchErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/loop/search",
      ...options,
    });
  }

  /**
   * Advance Search Menu Loop
   *
   * Advance search menu loop in the system
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * params: The parameters to search in menu loop name.
   * number_per_page: The number of records in each page.
   * page_index: The page index (number) to load.
   * return_keys_only: Whether the endpoint only return list of menu loop basic
   * (menu loop without menus in loop data).
   *
   * Returns:
   * List of menu loops found.
   */
  public postMenuLoopSearch<ThrowOnError extends boolean = false>(
    options?: Options<PostMenuLoopSearchData, ThrowOnError>,
  ) {
    return (options?.client ?? this.client).post<
      PostMenuLoopSearchResponses,
      PostMenuLoopSearchErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/loop/search",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Menu Loop
   *
   * Delete a menu loop
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * menu_loop_id: The menu loop ID to delete.
   *
   * Returns:
   * Deleted menu loop
   */
  public deleteMenuLoopByMenuLoopId<ThrowOnError extends boolean = false>(
    options: Options<DeleteMenuLoopByMenuLoopIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).delete<
      DeleteMenuLoopByMenuLoopIdResponses,
      DeleteMenuLoopByMenuLoopIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/loop/{menu_loop_id}",
      ...options,
    });
  }

  /**
   * Get Menu Loop
   *
   * Load a menu loop by ID
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * menu_loop_id: The menu loop ID to load.
   * enrichment_config: Config controlling which enrichment steps run.
   *
   * Returns:
   * Loaded menu loop.
   */
  public getMenuLoopByMenuLoopId<ThrowOnError extends boolean = false>(
    options: Options<GetMenuLoopByMenuLoopIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetMenuLoopByMenuLoopIdResponses,
      GetMenuLoopByMenuLoopIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/loop/{menu_loop_id}",
      ...options,
    });
  }

  /**
   * Update Menu Loop
   *
   * Update a menu loop
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * menu_loop_id: The menu loop ID to update.
   * menu_loop_update: The menu loop fields to update.
   *
   * Returns:
   * Updated menu loop.
   */
  public patchMenuLoopByMenuLoopId<ThrowOnError extends boolean = false>(
    options: Options<PatchMenuLoopByMenuLoopIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).patch<
      PatchMenuLoopByMenuLoopIdResponses,
      PatchMenuLoopByMenuLoopIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/loop/{menu_loop_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Copy Menu Loop
   *
   * Copy menu loop from another one
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * menu_loop_id: The menu loop ID to copy
   * params: The parameters to copy menu loop to create.
   *
   * Returns:
   * Copied menu loop.
   */
  public postMenuLoopByMenuLoopId<ThrowOnError extends boolean = false>(
    options: Options<PostMenuLoopByMenuLoopIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostMenuLoopByMenuLoopIdResponses,
      PostMenuLoopByMenuLoopIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/loop/{menu_loop_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Download Menu Loop Involved Foods
   *
   * Download every food involved in a menu loop as a ZIP of CSV files
   *
   * The archive matches the format of ``GET /food/items/download``: one CSV
   * per involved recipe food, plus a single ``ingredients.csv`` aggregating
   * every involved ingredient (non-recipe) food. Foods are collected across
   * all menus linked to the loop, transitively through sub-recipes.
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * menu_loop_id: The menu loop ID to export involved foods for.
   *
   * Returns:
   * The ZIP archive with the involved foods as CSV files.
   */
  public getMenuLoopByMenuLoopIdInvolvedFoodsDownload<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      GetMenuLoopByMenuLoopIdInvolvedFoodsDownloadData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).get<
      GetMenuLoopByMenuLoopIdInvolvedFoodsDownloadResponses,
      GetMenuLoopByMenuLoopIdInvolvedFoodsDownloadErrors,
      ThrowOnError
    >({
      responseType: "blob",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/loop/{menu_loop_id}/involved_foods/download",
      ...options,
    });
  }

  /**
   * Create Menu Loop
   *
   * Create menu loop
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * new_menu_loop: The menu loop to create.
   *
   * Returns:
   * Created menu loop.
   */
  public postMenuLoop<ThrowOnError extends boolean = false>(
    options: Options<PostMenuLoopData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostMenuLoopResponses,
      PostMenuLoopErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/loop",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Add Special Events To Menu Loop
   *
   * Add special date events to a menu loop
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * menu_loop_id: The menu loop ID to add special events to.
   * new_special_date_events: The new special date events to add to menu loop.
   *
   * Returns:
   * Updated menu loop.
   */
  public postMenuLoopByMenuLoopIdSkipDate<ThrowOnError extends boolean = false>(
    options: Options<PostMenuLoopByMenuLoopIdSkipDateData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostMenuLoopByMenuLoopIdSkipDateResponses,
      PostMenuLoopByMenuLoopIdSkipDateErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/menu/loop/{menu_loop_id}/skip_date",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class Ordering extends HeyApiClient {
  /**
   * Get Daily Meal Order Tickets
   *
   * Load meal order tickets on a date from the system
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * query_date: The date to load all meal order tickets.
   * tz_info_str: The optional timezone information. Default to server's timezone.
   *
   * Returns:
   * Load meal order tickets.
   */
  public getOrderTicketsDailyByQueryDate<ThrowOnError extends boolean = false>(
    options: Options<GetOrderTicketsDailyByQueryDateData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetOrderTicketsDailyByQueryDateResponses,
      GetOrderTicketsDailyByQueryDateErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/order/tickets/daily/{query_date}",
      ...options,
    });
  }

  /**
   * Get Meal Order Ticket
   *
   * Load meal order ticket from the system
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * meal_order_ticket_id: The meal order ticket's ID to load.
   *
   * Returns:
   * Load meal order ticket.
   */
  public getOrderMealByMealOrderTicketId<ThrowOnError extends boolean = false>(
    options: Options<GetOrderMealByMealOrderTicketIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetOrderMealByMealOrderTicketIdResponses,
      GetOrderMealByMealOrderTicketIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/order/meal/{meal_order_ticket_id}",
      ...options,
    });
  }

  /**
   * Update Meal Order
   *
   * Deep update a meal order ticket
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * meal_order_ticket_id: The meal order ticket's ID to update.
   * meal_order: The new meal order ticket data to deep-update.
   *
   * Returns:
   * The updated meal order ticket.
   */
  public patchOrderMealByMealOrderTicketId<
    ThrowOnError extends boolean = false,
  >(options: Options<PatchOrderMealByMealOrderTicketIdData, ThrowOnError>) {
    return (options.client ?? this.client).patch<
      PatchOrderMealByMealOrderTicketIdResponses,
      PatchOrderMealByMealOrderTicketIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/order/meal/{meal_order_ticket_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Place Meal Order
   *
   * Deep create a new meal order ticket
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * meal_order: The new meal order ticket data to deep-create.
   *
   * Returns:
   * Created meal order ticket.
   */
  public postOrderMeal<ThrowOnError extends boolean = false>(
    options: Options<PostOrderMealData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostOrderMealResponses,
      PostOrderMealErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/order/meal",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Item Production Numbers On Menus In Date Range
   *
   * Aggregate item production numbers on menus from a selected date range
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * date_start: The inclusive start date to load menus and aggregate item production numbers.
   * date_end: The inclusive end date to load menus and aggregate item production numbers.
   * tz_info_str: The optional timezone information. Default to server's timezone.
   *
   * Returns:
   * Dish orders in portions matching the item production number on menus.
   */
  public getOrderPortionAggregatedMenuProductionDateFromByDateStartToByDateEnd<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      GetOrderPortionAggregatedMenuProductionDateFromByDateStartToByDateEndData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).get<
      GetOrderPortionAggregatedMenuProductionDateFromByDateStartToByDateEndResponses,
      GetOrderPortionAggregatedMenuProductionDateFromByDateStartToByDateEndErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/order/portion/aggregated/menu_production/date/from/{date_start}/to/{date_end}",
      ...options,
    });
  }
}

export class Inventory extends HeyApiClient {
  /**
   * Extract Replenishment From Supplier Order Csv
   *
   * Extract replenishment and TBD list from uploaded supplier order CSV file
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * order_csv_file: The uploaded order CSV file
   * supplier_name: Name of the supplier.
   *
   * Returns:
   * List of GFS order records, list of resolved replenishment records to create.
   */
  public postInventoryStockReplenishmentSupplierOrderCsvFile<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      PostInventoryStockReplenishmentSupplierOrderCsvFileData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).post<
      PostInventoryStockReplenishmentSupplierOrderCsvFileResponses,
      PostInventoryStockReplenishmentSupplierOrderCsvFileErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/stock/replenishment/supplier_order_csv_file",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });
  }

  /**
   * Replenish Stock
   *
   * Replenish stock for a list of food items
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * records: The list of stock replenishment records to create.
   *
   * Returns:
   * List of stock replenishment records.
   */
  public postInventoryStockReplenishment<ThrowOnError extends boolean = false>(
    options: Options<PostInventoryStockReplenishmentData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostInventoryStockReplenishmentResponses,
      PostInventoryStockReplenishmentErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/stock/replenishment",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Deplete Stocks
   *
   * Deplete a list of food items
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * depletion_amounts: The list of food ID and their depletion amount.
   *
   * Returns:
   * List of stock depletion records.
   */
  public postInventoryStockDepletion<ThrowOnError extends boolean = false>(
    options: Options<PostInventoryStockDepletionData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostInventoryStockDepletionResponses,
      PostInventoryStockDepletionErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/stock/depletion",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Stock Detail Of A Food
   *
   * Get replenish stock records for a food item
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * food_id: The food item ID to get detail stock records.
   *
   * Returns:
   * The list of stock replenishment records for the food item.
   */
  public getInventoryStockByFoodIdDetail<ThrowOnError extends boolean = false>(
    options: Options<GetInventoryStockByFoodIdDetailData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetInventoryStockByFoodIdDetailResponses,
      GetInventoryStockByFoodIdDetailErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/stock/{food_id}/detail",
      ...options,
    });
  }

  /**
   * Get Stock Level Of A List Of Food Items
   *
   * Get the stock levels for a list of food items
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * food_ids: The food item IDs to get stock levels.
   *
   * Returns:
   * The list of food amounts that represents the stock levels for the food items.
   */
  public getInventoryStocks<ThrowOnError extends boolean = false>(
    options: Options<GetInventoryStocksData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetInventoryStocksResponses,
      GetInventoryStocksErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/stocks",
      ...options,
    });
  }

  /**
   * Search Food Stocks
   *
   * Search food item stocks in the system
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * keywords: The keywords to search food item stocks.
   * number_per_page: The number of records in each page.
   * page_index: The page index (number) to load.
   * only_procured_items: Optional flag to only search on items brought from suppliers.
   *
   * Returns:
   * The list of food amounts that represents the stock levels for the food items.
   */
  public getInventoryStocksSearch<ThrowOnError extends boolean = false>(
    options?: Options<GetInventoryStocksSearchData, ThrowOnError>,
  ) {
    return (options?.client ?? this.client).get<
      GetInventoryStocksSearchResponses,
      GetInventoryStocksSearchErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/stocks/search",
      ...options,
    });
  }
}

export class Purchasing extends HeyApiClient {
  /**
   * Get Purchasing Guide From Portion Orders
   *
   * Get primary food (ingredient) purchasing list from portion orders
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * required_dish_portion_orders:
   * The dish portion orders use to figure out the required primary food quantities.
   * reserved_dish_portion_orders:
   * The dish portion orders use to figure out the reserving primary food quantities.
   * filter_params:
   * Optional filter apply on the output of the ingredient purchase guide.
   * equivalent_selection:
   * Optional explicit mapping of main ingredient food ID to selected
   * equivalent group member food ID; merges over the auto-resolved
   * selection, explicit winning per group.
   * auto_resolve_equivalent_selection:
   * Auto-resolve the equivalent supplier selection from the site's
   * supply profiles (default on). The site is ``for_site_id`` when
   * given, else a site-locked account's own single site; unrestricted
   * accounts without ``for_site_id`` resolve nothing.
   * for_site_id:
   * The site whose supply profiles drive the resolution. Site-locked
   * accounts may only name their own sites (403 otherwise).
   *
   * Returns:
   * Food purchase guide that includes a list of primary food required to purchase.
   */
  public postInventoryPurchasingFromPortionOrders<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      PostInventoryPurchasingFromPortionOrdersData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).post<
      PostInventoryPurchasingFromPortionOrdersResponses,
      PostInventoryPurchasingFromPortionOrdersErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/purchasing/from_portion_orders",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Purchasing Guide From Custom Menus On Dates
   *
   * Get primary food (ingredient) purchasing list from custom menus on dates
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * required_menu_ids_on_dates:
   * The custom menu IDs on dates use to figure out the required primary food
   * quantities.
   * reserved_menu_ids_on_dates:
   * The custom menu IDs on dates use to figure out the reserving primary food
   * quantities.
   * filter_params:
   * Optional filter apply on the output of the ingredient purchase guide.
   * equivalent_selection:
   * Optional explicit mapping of main ingredient food ID to selected
   * equivalent group member food ID; merges over the auto-resolved
   * selection, explicit winning per group.
   * auto_resolve_equivalent_selection:
   * Auto-resolve the equivalent supplier selection from the site's
   * supply profiles (default on). The site is ``for_site_id`` when
   * given, else a site-locked account's own single site; unrestricted
   * accounts without ``for_site_id`` resolve nothing.
   * for_site_id:
   * The site whose supply profiles drive the resolution. Site-locked
   * accounts may only name their own sites (403 otherwise).
   *
   * Returns:
   * Food purchase guide that includes a list of primary food required to purchase.
   */
  public postInventoryPurchasingFromCustomMenusOnDates<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      PostInventoryPurchasingFromCustomMenusOnDatesData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).post<
      PostInventoryPurchasingFromCustomMenusOnDatesResponses,
      PostInventoryPurchasingFromCustomMenusOnDatesErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/purchasing/from_custom_menus_on_dates",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Purchasing Guide From Date Range
   *
   * Get primary food (ingredient) purchasing list from date range
   *
   * Args:
   * authorized_user: The authorized user (user that logged in).
   * db_session: The database session to use for this endpoint call.
   * required_date_range:
   * The date range use to figure out the required primary food quantities.
   * reserved_date_range:
   * The date range use to figure out the reserving primary food quantities.
   * tz_info_str:
   * Optional timezone string to use for date range interpretation.
   * Defaults to the system timezone if not provided.
   * menu_type:
   * The menu category type to filter menus by. Defaults to CYCLE_REG.
   * filter_params:
   * Optional filter apply on the output of the ingredient purchase guide.
   * Supports filtering by food cook origin and food categories.
   * equivalent_selection:
   * Optional explicit mapping of main ingredient food ID to selected
   * equivalent group member food ID; merges over the auto-resolved
   * selection, explicit winning per group.
   * auto_resolve_equivalent_selection:
   * Auto-resolve the equivalent supplier selection from the site's
   * supply profiles (default on). The site is ``for_site_id`` when
   * given, else a site-locked account's own single site; unrestricted
   * accounts without ``for_site_id`` resolve nothing.
   * for_site_id:
   * The site whose supply profiles drive the resolution, and the site
   * the menu reads narrow to. Site-locked accounts may only name
   * their own sites (403 otherwise).
   *
   * Returns:
   * Food purchase guide that includes a list of primary food required to purchase.
   */
  public postInventoryPurchasingFromDateRange<
    ThrowOnError extends boolean = false,
  >(options: Options<PostInventoryPurchasingFromDateRangeData, ThrowOnError>) {
    return (options.client ?? this.client).post<
      PostInventoryPurchasingFromDateRangeResponses,
      PostInventoryPurchasingFromDateRangeErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/purchasing/from_date_range",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class GfsOrderingSupplyProfile extends HeyApiClient {
  /**
   * List Active Profiles
   *
   * List all active supply profiles.
   */
  public getInventoryGfsOrderingFacility<ThrowOnError extends boolean = false>(
    options?: Options<GetInventoryGfsOrderingFacilityData, ThrowOnError>,
  ) {
    return (options?.client ?? this.client).get<
      GetInventoryGfsOrderingFacilityResponses,
      GetInventoryGfsOrderingFacilityErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/facility/",
      ...options,
    });
  }

  /**
   * Create Profile
   *
   * Create a new supply profile (admin only).
   */
  public postInventoryGfsOrderingFacility<ThrowOnError extends boolean = false>(
    options: Options<PostInventoryGfsOrderingFacilityData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).post<
      PostInventoryGfsOrderingFacilityResponses,
      PostInventoryGfsOrderingFacilityErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/facility/",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Get Profile
   *
   * Get a single supply profile by ID.
   */
  public getInventoryGfsOrderingFacilityByProfileId<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      GetInventoryGfsOrderingFacilityByProfileIdData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).get<
      GetInventoryGfsOrderingFacilityByProfileIdResponses,
      GetInventoryGfsOrderingFacilityByProfileIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/facility/{profile_id}",
      ...options,
    });
  }

  /**
   * Update Profile
   *
   * Update an existing supply profile (admin only). Only provided fields are changed.
   */
  public putInventoryGfsOrderingFacilityByProfileId<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      PutInventoryGfsOrderingFacilityByProfileIdData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).put<
      PutInventoryGfsOrderingFacilityByProfileIdResponses,
      PutInventoryGfsOrderingFacilityByProfileIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/facility/{profile_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * List All Profiles
   *
   * List all supply profiles including inactive (admin only).
   */
  public getInventoryGfsOrderingFacilityAdminAll<
    ThrowOnError extends boolean = false,
  >(
    options?: Options<
      GetInventoryGfsOrderingFacilityAdminAllData,
      ThrowOnError
    >,
  ) {
    return (options?.client ?? this.client).get<
      GetInventoryGfsOrderingFacilityAdminAllResponses,
      GetInventoryGfsOrderingFacilityAdminAllErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/facility/admin/all",
      ...options,
    });
  }

  /**
   * Set Ingredient Link
   *
   * Set which active supply profile of a site tracks an ingredient (admin only).
   *
   * One click in the ingredient × profile matrix: links the food to
   * ``supply_profile_id`` (moving it off any other active profile of the
   * site) or, with ``supply_profile_id`` explicitly ``null``, clears the link.
   */
  public putInventoryGfsOrderingFacilityIngredientLink<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      PutInventoryGfsOrderingFacilityIngredientLinkData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).put<
      PutInventoryGfsOrderingFacilityIngredientLinkResponses,
      PutInventoryGfsOrderingFacilityIngredientLinkErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/facility/ingredient-link",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Deactivate Profile
   *
   * Deactivate a supply profile (admin only).
   */
  public patchInventoryGfsOrderingFacilityByProfileIdDeactivate<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      PatchInventoryGfsOrderingFacilityByProfileIdDeactivateData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).patch<
      PatchInventoryGfsOrderingFacilityByProfileIdDeactivateResponses,
      PatchInventoryGfsOrderingFacilityByProfileIdDeactivateErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/facility/{profile_id}/deactivate",
      ...options,
    });
  }

  /**
   * Reactivate Profile
   *
   * Reactivate a supply profile (admin only).
   *
   * Goes through the deep update so the one-profile-per-ingredient rule is
   * re-checked: a profile whose tracked ingredients are now held by an
   * active sibling at the same site is rejected with 400.
   */
  public patchInventoryGfsOrderingFacilityByProfileIdReactivate<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      PatchInventoryGfsOrderingFacilityByProfileIdReactivateData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).patch<
      PatchInventoryGfsOrderingFacilityByProfileIdReactivateResponses,
      PatchInventoryGfsOrderingFacilityByProfileIdReactivateErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/facility/{profile_id}/reactivate",
      ...options,
    });
  }
}

export class GfsOrderingSupplyOrders extends HeyApiClient {
  /**
   * List Orders
   *
   * List the 50 most recent orders for a facility.
   */
  public getInventoryGfsOrderingOrders<ThrowOnError extends boolean = false>(
    options: Options<GetInventoryGfsOrderingOrdersData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetInventoryGfsOrderingOrdersResponses,
      GetInventoryGfsOrderingOrdersErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/orders/",
      ...options,
    });
  }

  /**
   * Get Order
   *
   * Get full order detail with line items.
   */
  public getInventoryGfsOrderingOrdersByOrderId<
    ThrowOnError extends boolean = false,
  >(
    options: Options<GetInventoryGfsOrderingOrdersByOrderIdData, ThrowOnError>,
  ) {
    return (options.client ?? this.client).get<
      GetInventoryGfsOrderingOrdersByOrderIdResponses,
      GetInventoryGfsOrderingOrdersByOrderIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/orders/{order_id}",
      ...options,
    });
  }
}

export class GfsOrderingProcurement extends HeyApiClient {
  /**
   * Get Upcoming Orders
   *
   * Compute upcoming order dates from the facility schedule
   * and check for existing draft orders.
   */
  public getInventoryGfsOrderingPurchasingUpcomingOrders<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      GetInventoryGfsOrderingPurchasingUpcomingOrdersData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).get<
      GetInventoryGfsOrderingPurchasingUpcomingOrdersResponses,
      GetInventoryGfsOrderingPurchasingUpcomingOrdersErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/purchasing/upcoming-orders",
      ...options,
    });
  }

  /**
   * Get Purchase List
   *
   * Get purchase list for a facility and order date.
   *
   * Returns existing draft if one exists, otherwise creates a new one.
   */
  public getInventoryGfsOrderingPurchasingList<
    ThrowOnError extends boolean = false,
  >(options: Options<GetInventoryGfsOrderingPurchasingListData, ThrowOnError>) {
    return (options.client ?? this.client).get<
      GetInventoryGfsOrderingPurchasingListResponses,
      GetInventoryGfsOrderingPurchasingListErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/purchasing/list",
      ...options,
    });
  }

  /**
   * Refresh Purchase List
   *
   * Discard current order and re-fetch from Jasper.
   *
   * Uses FOR UPDATE to prevent race conditions.
   */
  public postInventoryGfsOrderingPurchasingRefresh<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      PostInventoryGfsOrderingPurchasingRefreshData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).post<
      PostInventoryGfsOrderingPurchasingRefreshResponses,
      PostInventoryGfsOrderingPurchasingRefreshErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/purchasing/refresh",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Update Inventory
   *
   * Chef submits current inventory values for ingredients in an order.
   *
   * Recalculates purchase quantities based on the new inventory data.
   */
  public postInventoryGfsOrderingPurchasingUpdateInventory<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      PostInventoryGfsOrderingPurchasingUpdateInventoryData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).post<
      PostInventoryGfsOrderingPurchasingUpdateInventoryResponses,
      PostInventoryGfsOrderingPurchasingUpdateInventoryErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/purchasing/update-inventory",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Adjust Purchase List
   *
   * User adjusts the purchase amount of one or more lines, with a reason.
   *
   * This is the post-inventory feedback step: the operator tweaks the amount
   * to purchase (entered as boxes in the UI, converted to grams) and must give
   * a reason, which is stored on the line's notes. The order is located by
   * order_id; each line by food_id. Unknown food_ids are skipped.
   */
  public postInventoryGfsOrderingPurchasingAdjust<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      PostInventoryGfsOrderingPurchasingAdjustData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).post<
      PostInventoryGfsOrderingPurchasingAdjustResponses,
      PostInventoryGfsOrderingPurchasingAdjustErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/purchasing/adjust",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  /**
   * Download Csv
   *
   * Generate and download the GFS CSV for an order.
   */
  public getInventoryGfsOrderingPurchasingCsvByOrderId<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      GetInventoryGfsOrderingPurchasingCsvByOrderIdData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).get<
      GetInventoryGfsOrderingPurchasingCsvByOrderIdResponses,
      GetInventoryGfsOrderingPurchasingCsvByOrderIdErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/purchasing/csv/{order_id}",
      ...options,
    });
  }

  /**
   * List Order Csvs
   *
   * List a supply order's uploaded CSV history, active first.
   *
   * Each entry carries a short-lived presigned download URL.
   */
  public getInventoryGfsOrderingPurchasingOrderCsv<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      GetInventoryGfsOrderingPurchasingOrderCsvData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).get<
      GetInventoryGfsOrderingPurchasingOrderCsvResponses,
      GetInventoryGfsOrderingPurchasingOrderCsvErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/purchasing/order-csv",
      ...options,
    });
  }

  /**
   * Upload Order Csv
   *
   * Upload a supplier order CSV and link it to a supply order.
   *
   * The operator downloads the order CSV from the supplier (GFS, English or
   * French) after placing the order, then uploads it here. The raw file is
   * stored in object storage and linked to the order so a later feature can
   * compare the system-generated purchase list against the order actually
   * placed.
   *
   * Re-uploading for the same order is the **swap**: it supersedes the previous
   * active CSV (history is retained, never deleted). Uploading locks the order
   * against ``/refresh``.
   *
   * Only the container format (CSV) and size are validated here — GFS exports
   * differ by language, and parsing is deferred to the analysis feature.
   */
  public postInventoryGfsOrderingPurchasingOrderCsv<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      PostInventoryGfsOrderingPurchasingOrderCsvData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).post<
      PostInventoryGfsOrderingPurchasingOrderCsvResponses,
      PostInventoryGfsOrderingPurchasingOrderCsvErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/purchasing/order-csv",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });
  }

  /**
   * Get Order Csv Analysis
   *
   * Read the stored coverage analysis for an order's active uploaded CSV.
   *
   * The analysis is computed by a background sweep once the upload has been
   * stable for the configured window — this endpoint never computes inline.
   * 404 while no order / no uploaded CSV / analysis still pending. A
   * ``failed`` analysis is returned as-is with its error message.
   */
  public getInventoryGfsOrderingPurchasingOrderCsvAnalysis<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      GetInventoryGfsOrderingPurchasingOrderCsvAnalysisData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? this.client).get<
      GetInventoryGfsOrderingPurchasingOrderCsvAnalysisResponses,
      GetInventoryGfsOrderingPurchasingOrderCsvAnalysisErrors,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/inventory/gfs_ordering/purchasing/order-csv/analysis",
      ...options,
    });
  }
}

export class JasperPlatformApiClient extends HeyApiClient {
  public static readonly __registry =
    new HeyApiRegistry<JasperPlatformApiClient>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    JasperPlatformApiClient.__registry.set(this, args?.key);
  }

  private _authentication?: Authentication;
  get authentication(): Authentication {
    return (this._authentication ??= new Authentication({
      client: this.client,
    }));
  }

  private _user?: User;
  get user(): User {
    return (this._user ??= new User({ client: this.client }));
  }

  private _dietProfile?: DietProfile;
  get dietProfile(): DietProfile {
    return (this._dietProfile ??= new DietProfile({ client: this.client }));
  }

  private _foodTag?: FoodTag;
  get foodTag(): FoodTag {
    return (this._foodTag ??= new FoodTag({ client: this.client }));
  }

  private _foodItem?: FoodItem;
  get foodItem(): FoodItem {
    return (this._foodItem ??= new FoodItem({ client: this.client }));
  }

  private _foodGroup?: FoodGroup;
  get foodGroup(): FoodGroup {
    return (this._foodGroup ??= new FoodGroup({ client: this.client }));
  }

  private _ingredient?: Ingredient;
  get ingredient(): Ingredient {
    return (this._ingredient ??= new Ingredient({ client: this.client }));
  }

  private _recipe?: Recipe;
  get recipe(): Recipe {
    return (this._recipe ??= new Recipe({ client: this.client }));
  }

  private _menu?: Menu;
  get menu(): Menu {
    return (this._menu ??= new Menu({ client: this.client }));
  }

  private _menuLoop?: MenuLoop;
  get menuLoop(): MenuLoop {
    return (this._menuLoop ??= new MenuLoop({ client: this.client }));
  }

  private _ordering?: Ordering;
  get ordering(): Ordering {
    return (this._ordering ??= new Ordering({ client: this.client }));
  }

  private _inventory?: Inventory;
  get inventory(): Inventory {
    return (this._inventory ??= new Inventory({ client: this.client }));
  }

  private _purchasing?: Purchasing;
  get purchasing(): Purchasing {
    return (this._purchasing ??= new Purchasing({ client: this.client }));
  }

  private _gfsOrderingSupplyProfile?: GfsOrderingSupplyProfile;
  get gfsOrderingSupplyProfile(): GfsOrderingSupplyProfile {
    return (this._gfsOrderingSupplyProfile ??= new GfsOrderingSupplyProfile({
      client: this.client,
    }));
  }

  private _gfsOrderingSupplyOrders?: GfsOrderingSupplyOrders;
  get gfsOrderingSupplyOrders(): GfsOrderingSupplyOrders {
    return (this._gfsOrderingSupplyOrders ??= new GfsOrderingSupplyOrders({
      client: this.client,
    }));
  }

  private _gfsOrderingProcurement?: GfsOrderingProcurement;
  get gfsOrderingProcurement(): GfsOrderingProcurement {
    return (this._gfsOrderingProcurement ??= new GfsOrderingProcurement({
      client: this.client,
    }));
  }
}
